import TicketStatus from './TicketStatus';
import { TicketStatusProps, TicketStatusValueProps } from './types';

export type { TicketStatusProps, TicketStatusValueProps };
export default TicketStatus;
